import * as icon from '@campoint/odi-ui-icons';
import { Icon, IconProps } from '@chakra-ui/react';

const ErrorIcon: React.FC<IconProps> = (props) => (
  <Icon as={icon.Error} boxSize={'icon.md'} color={'error.500'} {...props} />
);

export default ErrorIcon;
